import { Typography } from "@mui/material";
import React from "react";

interface StepTitleProps {
  children: React.ReactNode;
}

const StepTitle: React.FC<StepTitleProps> = ({ children }) => (
  <Typography
    variant="h4"
    sx={{ textAlign: "left", mb: { xs: 0, md: 1 }, width: "100%" }}
    gutterBottom
  >
    {children}
  </Typography>
);

export default StepTitle;
